import { Observable } from 'rxjs';
import { WarrantyProcessRequest } from '../../model/warranty-process.model';


export abstract class WarrantyProcessAdapter {
  abstract startWarrantyProcess(
    request: WarrantyProcessRequest
  ): Observable<void>;
}
